// Formatting helpers

export const fmtUSD = (n, opts = {}) => {
    const { decimals = 0, signDisplay = "auto" } = opts;
    if (!Number.isFinite(n)) return "—";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        signDisplay,
    }).format(n);
};

export const fmtPct = (n, decimals = 2) => {
    if (!Number.isFinite(n)) return "—";
    return `${n.toFixed(decimals)}%`;
};

export const fmtNum = (n, decimals = 0) => {
    if (!Number.isFinite(n)) return "—";
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(n);
};

export const fmtMonths = (m) => {
    if (!Number.isFinite(m)) return "—";
    if (m === Infinity) return "never";
    const y = Math.floor(m / 12);
    const rem = Math.round(m % 12);
    if (y === 0) return `${rem} mo`;
    if (rem === 0) return `${y} yr`;
    return `${y} yr ${rem} mo`;
};
